import {ProductionMachineListQueryForm} from './production-machine.model';

export const queryKey = {
  all: ['production', 'machines'] as const,
  list: (queryForm: ProductionMachineListQueryForm) => [...queryKey.all, queryForm] as const,
  listByIds: (ids: URLSearchParams) => [...queryKey.all, 'ids', ids.toString()] as const,
};
